// COUPLUS WEIHAI(쿠패스) 메뉴 이름 — 사이드바·페이지 제목·브라우저 탭 제목이 이 한 곳을 같이 쓴다.
// 이름을 바꿀 때 여기만 고치면 세 군데가 같이 바뀐다(2026-10 YZY 메뉴 개편 때 어긋나서 한 곳으로 모았다).
// 사이드바의 순서·업무 그룹(采购/入库/出库/库存/系统)은 SidebarStyle.vue 가 정한다(2026-10-04 YZY). 화면 문구 규칙대로 중국어(한국어 병기).
export const COUPASS_MENU = [
  { route: 'logis.logisreqpurchaseV0', title: '商品求购(구매요청)' },
  { route: 'logis.logisinboundregister', title: '入仓登记(입창등록)' },
  { route: 'logis.logispaidorderlist', title: '订单列表(구매리스트)' },
  { route: 'logis.logisaddimportV0', title: '入库处理(입고처리)' },
  // 화주·바코드별 식검/KC 한글표시사항 + KC 인증서류(2026-10-07 YZY)
  { route: 'logis.productlabels', title: '韩文标签资料(한글표시사항)' },
  { route: 'logis.logisinboundlist', title: '入库列表(입고리스트)' },
  { route: 'logis.logisimporterrorlist', title: '代办列表(확인리스트)' },
  // 入库列表 의 「待客户确认」 탭을 따로 꺼낸 메뉴 — 같은 화면(logisInboundListV0)을 상태만 고정해 연다(2026-10-04 YZY)
  { route: 'logis.logisinboundconfirm', title: '待客户确认(고객확인대기)' },
  { route: 'logis.logisshipoutrequest', title: '库存出库(재고출고)' },
  { route: 'logis.warehousemanagement', title: '出库列表(출고리스트)' },
  { route: 'logis.invoicelicenses', title: '营业执照管理(사업자등록증)' },
  // 관세사가 BL 마다 보내는 청구서·정산서·수입신고필증을 빠짐없이 모은다(2026-10-06 주인·YZY). 2026-10-12 YZY: 이 페이지가 出库装船BL清单 이 됐다(关税结算单 기능 그대로)
  { route: 'logis.customssettlement', title: '出库装船BL清单(출고 선적 BL 리스트 · 关税结算单 포함)' },
  // LCL 표(고객별 1행) → 고객마다 통합통관 청구서 파일 1개(2026-10-07 YZY). 시스템 저장 안 함 — 나중에 출고 청구 자동생성으로 대체할 임시 도구
  { route: 'logis.lclbillsplit', title: '合并账单拆分(청구서 나누기)' },
  // 사이드바 메뉴 아님 — 出库列表 안 탭(2026-10-04 YZY). 주소로 열 때 제목에 쓴다
  { route: 'logis.invoicerecords', title: '箱单发票列表(서류목록)' },
  { route: 'logis.logisstocklist', title: '库存列表(재고리스트)' },
  { route: 'logis.logisphotolibrary', title: '商品照片库(이미지)' },
  { route: 'logis.boxphotostatus', title: '箱子入库资料(박스 입고자료)' },
  { route: 'logis.boxphotoscan', title: '扫码上传入库资料(박스 입고자료 QR)' },
  { route: 'logis.ownerleader', title: '客户和客户负责人(화주-조장 담당)' },
  { route: 'logis.logisnotify', title: '通知(공지)' },
  { route: 'logis.logisuserlist', title: '用户(사용자)' },
  { route: 'logis.staffaccounts', title: '子账号管理(직원 계정)' },
  { route: 'logis.csassistant', title: '客服助手(CS 보조)' },
  { route: 'logis.feedbackboard', title: '需求进度(요청 진행 현황)' }
];

const BY_ROUTE = {};
COUPASS_MENU.forEach(m => { BY_ROUTE[m.route] = m.title; });

// 라우트 이름 → 메뉴 이름(없으면 '')
export function coupassMenuTitle(routeName) {
  return BY_ROUTE[routeName] || '';
}

export default COUPASS_MENU;

// ── 상단 탭 바(2026-10-04 YZY) ── 쿠패스 사이드바 블록의 메뉴(旧系统 포함)일 때만 탭으로 연다.
// 셀러 화면은 여기 없는 라우트라 탭 바도 keep-alive 도 안 걸린다(layouts/backend/Layout-1.vue 분기).
// 旧系统 메뉴 이름은 사이드바 문구 그대로 — 브라우저 탭 제목(coupassMenuTitle)에는 쓰지 않는다.
const LEGACY_TAB_TITLES = {
  'logis.logisreqpurchase': '商品代购(구매대행)',
  'logis.logispurchaselist': '订单列表(구매내역)',
  'logis.logisTotalList': '订单列表(종합리스트)',
  'logis.logisimportbox': '商品入库(입고)',
  'logis.logisaddimport': '商品入出库(입출고)',
  'logis.logisimportlist': '出库列表(출고내역)'
};
// 箱单发票列表 은 사이드바 메뉴가 아니다(出库列表 안 탭) — 탭 대상에서 뺀다
const TAB_ROUTES = new Set(COUPASS_MENU.map(m => m.route).filter(r => r !== 'logis.invoicerecords').concat(Object.keys(LEGACY_TAB_TITLES)));

export function isCoupassTabRoute(routeName) {
  return !!routeName && TAB_ROUTES.has(routeName);
}

export function coupassTabTitle(routeName) {
  return BY_ROUTE[routeName] || LEGACY_TAB_TITLES[routeName] || routeName;
}
